import React, { ReactNode } from "react";

import { PageLayout } from "@brz-components/layout";
import { PageContextProvider, PagePropsModel, TemplateSettingsProps } from "./contexts/page.context";

import { PageSettingsDataModel } from "@brz-types/common/page.settings.type";
import { PartnerContextWrapper } from "./contexts/partner.context";
import { CoBrandingContextWrapper } from "./contexts/cobrand.context";
import { AgentContextWrapper } from "./contexts/agent.context";

type PageContentRendererProps = {
    children: ReactNode | ReactNode[];
    settings: PageSettingsDataModel;
    template?: TemplateSettingsProps;
    pageProps?: PagePropsModel;
};

/**
 * A wrapper component that wraps page content component in PageContextProvider and PageLayout 
 * @param props `{ settings: PageSettingsDataModel }`
 */
export const PageContentRenderer = (props: PageContentRendererProps) => {

    return <PageContextProvider pageSettings={props.settings} templateSettings={props.template} pageProps={props.pageProps}>
        <PartnerContextWrapper>
            <CoBrandingContextWrapper>
                <AgentContextWrapper>
                    <PageLayout>
                        {props.children}
                    </PageLayout>
                </AgentContextWrapper>
            </CoBrandingContextWrapper>
        </PartnerContextWrapper>
    </PageContextProvider>;
};